import romanApi, { type RomanApiError } from "@roman/shared/lib/net/romanApi";
import useSWR, { type SWRConfiguration } from "swr";

type GetPotentialFreePointsArg = {
  predictionMarketChoiceId: string;
  freePoints: string;
};

type GetPotentialFreePointsResponse = {
  potentialFreePoints: string;
};

const fetcher = (url: string) => {
  return romanApi.get<GetPotentialFreePointsResponse>(url);
};

export const useGetPotentialFreePoints = (
  args: GetPotentialFreePointsArg | null,
  swrOptions?: SWRConfiguration<GetPotentialFreePointsResponse, RomanApiError>,
) => {
  const key = args
    ? `/prediction-market/potential-free-points/${args.predictionMarketChoiceId}?freePoints=${args.freePoints}`
    : null;

  const { data, error, isLoading, mutate } = useSWR<GetPotentialFreePointsResponse, RomanApiError>(
    key,
    fetcher,
    swrOptions,
  );

  return {
    data,
    isLoading,
    error,
    mutate,
  };
};
